import Share from 'ninelines-sharing';

const init = () => {
	if (document.querySelector('[data-social]')) {
		const list = document.querySelectorAll('[data-social]');

		Array.prototype.forEach.call(list, (item) => {
			item.addEventListener('click', (e) => {
				let $test = $('.test');
				let shareWindow = Share.openWindow('');
				const social = e.currentTarget.dataset.social;

				if ($test.length) {
					let url = `${location.origin}/share.php?page=result${$test.find('.test__result').data('result')}`;
					shareWindow.location = {
						facebook: `https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
						vk: `https://vk.com/share.php?url=${encodeURIComponent(url)}`,
						twitter: `http://twitter.com/share?url=${encodeURIComponent(url)}`,
						ok: `https://connect.ok.ru/offer?url=${encodeURIComponent(url)}`,
					}[social];
				} else {
					let url = location.origin + location.pathname;

					Share[social](url);
				}
			});
		});
	}
};

export default {
	init,
};
